import { ListItem } from "@tokenterminal/ui/List"
import { DataSnippetPlaceholder } from "components/v3/DataSnippet/DataSnippetPlaceholder"
import { AsideList, AsideListScrollContainer } from "./AsideList"
import { asideListItem } from "./AsideList.css"

export function AsideSkeleton({ limit = 15 }: { limit?: number }) {
  return (
    <AsideListScrollContainer>
      <AsideList currentPage={null}>
        {Array(limit)
          .fill(null)
          .map((_, i) => (
            <ListItem className={asideListItem} key={i} data-placeholder>
              <DataSnippetPlaceholder />
            </ListItem>
          ))}
      </AsideList>
    </AsideListScrollContainer>
  )
}
